import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
import { Button } from '../ui/button';
import { logger } from '../../utils/logger';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function LiveTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${API_URL}/api/testimonials/approved`)
      .then(r => r.json())
      .then(data => { setTestimonials(data.testimonials || []); setLoading(false); })
      .catch((err) => { logger.error('Failed to load testimonials:', err); setLoading(false); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return null;
  if (testimonials.length === 0) {
    return (
      <section className="py-24 bg-[var(--bg-base)]" data-testid="testimonials-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-space text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">What users <span className="pi-gradient-text">will say</span></h2>
          <p className="text-white/30 text-base mb-8">We're launching soon. Be the first to try SendPI and share your experience.</p>
          <Link to="/signup"><Button className="shimmer-btn text-white rounded-full px-8 py-5 font-space font-bold border-0" data-testid="testimonials-cta">Be the first to share <ArrowRight className="w-4 h-4 ml-2" /></Button></Link>
        </div>
      </section>
    );
  }
  return (
    <section className="py-24 bg-[var(--bg-base)]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16"><h2 className="font-space text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">Loved by <span className="pi-gradient-text">our users</span></h2></div>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((t, i) => (
            <motion.div key={t.id} className="glass-card rounded-2xl p-8" initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
              <div className="flex items-center gap-1 mb-4">{[...Array(5)].map((_, j) => <Star key={`star-${t.id}-${j}`} className="w-4 h-4 fill-amber-400 text-amber-400" />)}</div>
              <p className="text-white/60 mb-6 italic text-sm leading-relaxed">"{t.quote}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full pi-gradient flex items-center justify-center text-white text-sm font-bold">{t.user_name?.[0]?.toUpperCase() || 'U'}</div>
                <div>
                  <p className="text-white font-space font-bold text-sm">{t.user_name}</p>
                  {t.role && <p className="text-white/30 text-xs">{t.role}</p>}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
